
  import { Vue, Component, Prop, PropSync } from "vue-property-decorator";
  import EmployeeCard from "@/components/employee/EmployeeCard.vue";
  import RouteParams from "@/entities/RouteParams";
  import CardItemTitle from "@/components/card/CardItemTitle.vue";
  import CardItemValue from "@/components/card/CardItemValue.vue";
  import CardItemBaseContainer from "@/components/card/CardItemBaseContainer.vue";
  import ItemChipsWithMore from "@/components/common/ItemChipsWithMore.vue";
  import ItemChipsData from "@/entities/ItemChipsData";
  import { User_Skill } from "@/generated/graphql";
  import CardBodyItem from "@/components/card/CardBodyItem.vue";
  import { NO_INFORMATION } from '@/data/placeholders';
  import CardItemChipsContainer from "@/components/card/CardItemChipsContainer.vue";
  import ContainerSize from "@/components/uiSize/ContainerSize.vue";
  import ChipWithLinkData from "@/types/ChipWithLinkData";
import ChipsWithMore from "@/components/common/ChipsWithMore.vue";

  @Component({
    components: {
      ContainerSize,
      CardItemChipsContainer,
      CardBodyItem,
      ItemChipsWithMore,
      CardItemBaseContainer,
      CardItemValue,
      CardItemTitle,
      EmployeeCard,
      ChipsWithMore,
    },
  })
  export default class ContractorEmployeeCard extends Vue {
    @Prop({ type: Object, required: true }) readonly employeePageRouteParams!: RouteParams<{ id: string }>;
    @Prop({ type: String, required: true }) readonly userUpdatedDate!: string;
    @Prop({ type: String, required: true }) readonly employeeUserId!: string;
    @Prop({ type: String, required: true }) readonly givenName!: string;
    @Prop({ type: String, required: true }) readonly familyName!: string;
    @Prop({ type: String, default: undefined }) readonly jobTitle?: string;
    @Prop({ type: Number, default: undefined }) readonly minRate?: number;
    @Prop({ type: Number, default: undefined }) readonly maxRate?: number;
    @Prop({ type: String, default: undefined }) readonly companyName?: string;
    @Prop({ type: String, default: undefined }) readonly avatar?: string;
    @Prop({ type: String, default: undefined }) readonly country?: string;
    @Prop({ type: String, default: undefined }) readonly city?: string;
    @Prop({ type: Boolean, default: false }) readonly available!: boolean;
    @Prop({ type: Array, default: () => [] }) readonly skills!: User_Skill[];
    @PropSync('nameBlockMinHeight', { type: Number, default: undefined }) nameBlockMinHeightValue?: number;
    @PropSync('skillsBlockMinHeight', { type: Number, default: undefined }) skillsBlockMinHeightValue?: number;

    noInformationPlaceholder = NO_INFORMATION;

    get contractorSkills(): ItemChipsData[] {
      return this.skills.map(({ skill }) => ({
        id: String(skill.id),
        name: String(skill.name),
      }));
    }

    get skillss(): ChipWithLinkData[] {
    let skills = this.skills.map(({ skill }) => skill);
    const skillss = skills.reduce((filtered, skill) => {
      let chipWithLinkData: ChipWithLinkData = {
        variant: "blue",
        chipLink: this.employeePageRouteParams,
        chipData: { id: skill.id.toString(), name: skill.name },
        avatar: "",
        chipText: ""
      };
      filtered.push(chipWithLinkData);
      return filtered;
    }, []);
    // skills.sort((a, b) => a.variant.localeCompare(b.variant));
    return skillss;
  }

    get rates(): string | undefined {
      if (this.minRate && this.maxRate) {
        return `$${this.minRate} - $${this.maxRate}`;
      }
      if (this.minRate && !this.maxRate) {
        return `from $${this.minRate}`;
      }
      if (!this.minRate && this.maxRate) {
        return `up to $${this.maxRate}`;
      }
      return undefined;
    }

  }
